import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCaretRight, faPencilAlt } from '@fortawesome/free-solid-svg-icons';

import { adminPaneGrey } from 'common/constants/colors';
import { ATTRIBUTE_PROPTYPE, ATTRIBUTE_TYPE_PROPTYPE, SECTION_PROPTYPE, GENRE_PROPTYPE } from 'common/constants/commonPropTypes';

const PaneItem = ({ item, isSelected, onClick, onEdit }) => (
  <div
    onClick={onClick}
    role="button"
    style={{
      alignItems: 'center',
      background: isSelected ? adminPaneGrey : '',
      borderRadius: '5px',
      display: 'flex',
      fontSize: '16px',
      justifyContent: 'space-between',
      margin: '10px 10px',
      padding: '10px 0',
    }}
  >
    <div style={{ marginLeft: '15px' }}>{item.description}</div>
    <div style={{ marginRight: '15px' }}>
      {isSelected && <FontAwesomeIcon icon={faPencilAlt} onClick={onEdit} style={{ marginRight: '10px' }} />}
      <FontAwesomeIcon icon={faCaretRight} />
    </div>
  </div>
);
PaneItem.propTypes = {
  item: PropTypes.oneOfType([
    ATTRIBUTE_PROPTYPE,
    ATTRIBUTE_TYPE_PROPTYPE,
    SECTION_PROPTYPE,
    GENRE_PROPTYPE,
  ]).isRequired,
  isSelected: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
  onEdit: PropTypes.func.isRequired,
};
PaneItem.defaultProps = { isSelected: false };

export default PaneItem;
